/**
 * Versão promise de dormir por n milisegundos.
 *
 * @param {number} timeout
 * @return {Promise<void>}
 */
export async function sleep(timeout) {
    return new Promise(resolve => setTimeout(resolve, timeout))
}
